/* DSL LinkedIn Insight Tag — pageview + custom conversion ID */
(function(){
  var CFG = window.DSL_CONFIG || {};
  if (!CFG.linkedinPartnerId) return;
  var c = window.DSL_CONSENT && window.DSL_CONSENT.get();
  if (c && c.marketing === false) return;
  window._linkedin_data_partner_ids = [CFG.linkedinPartnerId];
  var s = document.createElement("script"); s.async = true; s.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
  document.head.appendChild(s);
})();